module.exports = __webpack_public_path__ + "static/media/main.95df8948.png";